import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Bot } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { API, errText, useAuth } from "@/lib/auth";
import { useAccess } from "@/lib/access";
import { Positions, Summary } from "./PaperPortfolio";
import { paperChanged } from "./utils";
import { useMode } from "@/components/engage/ModeCard";

export const PicksBotCard = ({ onOpen }) => {
  const { owner } = useAccess();
  const [d, setD] = useState(null);
  const { profile } = useAuth();
  const [md] = useMode();
  const rule = md && md.modes[md.mode];
  const canCopy = (b) => !rule || ((!rule.groups || rule.groups.includes(b.group)) && (!rule.types || !b.market_type || rule.types.includes(b.market_type)));
  const copy = async (b) => {
    if (!profile) return toast.error("Sign in to copy the bot's picks");
    try { const { data } = await axios.post(`${API}/predict/paper/bet`, { slug: b.slug, side: b.side, amount: 10 }); toast.success(`Copied: ${data.contracts} × ${data.side_name} for $${data.cost.toFixed(2)} (practice)`); paperChanged(); }
    catch (e) { toast.error(errText(e)); }
  };
  const load = () => axios.get(`${API}/predict/bot`).then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); const id = setInterval(load, 120000); return () => clearInterval(id); }, []);
  const toggle = async (on) => {
    try { await axios.post(`${API}/predict/bot/config`, { enabled: on }); load(); } catch (e) { toast.error(errText(e)); }
  };
  if (!d) return null;
  return (
    <section className="glass p-5 space-y-4" data-testid="picks-bot-card">
      <div className="flex items-center justify-between gap-3">
        <h2 className="font-head font-semibold flex items-center gap-2"><Bot className="w-4 h-4 text-[var(--violet)]" />Practice bot track record</h2>
        <div className="flex items-center gap-2 text-xs text-slate-400">{d.config.enabled ? "Running" : "Paused"}
          {owner && <Switch checked={d.config.enabled} onCheckedChange={toggle} data-testid="picks-bot-switch" />}</div>
      </div>
      <p className="text-xs text-slate-400">{d.rule} Stake ${d.config.stake} per pick · paper money.</p>
      <Summary d={d} testid="picks-bot-summary" />
      {d.open.length > 0 && <details><summary className="text-xs text-slate-400 cursor-pointer" data-testid="picks-bot-open-toggle">Open picks ({d.open.length})</summary><Positions rows={d.open} onOpen={onOpen} onCopy={copy} canCopy={canCopy} prefix="bot" /></details>}
      {d.closed.length > 0 && <details><summary className="text-xs text-slate-400 cursor-pointer">Settled ({d.closed.length})</summary><Positions rows={d.closed} onOpen={onOpen} prefix="bot-h" /></details>}
    </section>
  );
};
